(function() {
  'use strict';

  var section = document.querySelector('[data-app-tour]');
  if (!section) return;

  var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-tour-step]'));
  var screens = Array.prototype.slice.call(section.querySelectorAll('.fp-appx__screen'));
  var panel = section.querySelector('.fp-appx__panel');
  var stage = section.querySelector('.fp-appx__stage');
  var phone = section.querySelector('.fp-appx__phone');
  var toast = section.querySelector('.fp-appx__toast');
  var toastTitle = toast && toast.querySelector('[data-toast-title]');
  var toastText = toast && toast.querySelector('[data-toast-text]');
  if (!tabs.length || tabs.length !== screens.length) return;

  var TOUR_MS = 4200;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  var current = 0;
  var timer = 0;
  var inView = false;
  var hovering = false;

  section.style.setProperty('--tour-ms', TOUR_MS + 'ms');

  function restartClass(el, name) {
    el.classList.remove(name);
    void el.offsetWidth;
    el.classList.add(name);
  }

  function setStep(index) {
    current = (index + tabs.length) % tabs.length;
    tabs.forEach(function(tab, i) {
      var on = i === current;
      tab.classList.toggle('is-on', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    screens.forEach(function(screen, i) {
      screen.classList.toggle('is-on', i === current);
    });
    if (toast) {
      var tab = tabs[current];
      if (toastTitle) toastTitle.textContent = tab.getAttribute('data-toast-title') || '';
      if (toastText) toastText.textContent = tab.getAttribute('data-toast') || '';
      restartClass(toast, 'is-popping');
    }
  }

  function canAutoplay() {
    return !reducedMotion.matches && inView && !hovering && !document.hidden;
  }

  function stop() {
    clearTimeout(timer);
    timer = 0;
  }

  function schedule() {
    stop();
    if (!canAutoplay()) return;
    section.classList.add('is-touring');
    timer = setTimeout(function() {
      setStep(current + 1);
      schedule();
    }, TOUR_MS);
  }

  function restartProgress() {
    var tab = tabs[current];
    tab.classList.remove('is-on');
    void tab.offsetWidth;
    tab.classList.add('is-on');
  }

  tabs.forEach(function(tab, i) {
    tab.addEventListener('click', function() {
      setStep(i);
      schedule();
    });
    tab.addEventListener('keydown', function(event) {
      var key = event.key;
      var delta = key === 'ArrowDown' || key === 'ArrowRight' ? 1 : key === 'ArrowUp' || key === 'ArrowLeft' ? -1 : 0;
      if (!delta) return;
      event.preventDefault();
      setStep(current + delta);
      tabs[current].focus();
      schedule();
    });
  });

  if (panel) {
    panel.addEventListener('pointerenter', function(event) {
      if (event.pointerType !== 'mouse') return;
      hovering = true;
      section.classList.add('is-paused');
      stop();
    });
    panel.addEventListener('pointerleave', function(event) {
      if (event.pointerType !== 'mouse') return;
      hovering = false;
      section.classList.remove('is-paused');
      if (phone) {
        phone.style.removeProperty('--tilt-x');
        phone.style.removeProperty('--tilt-y');
      }
      restartProgress();
      schedule();
    });
  }

  if (stage && phone) {
    stage.addEventListener('pointermove', function(event) {
      if (!finePointer.matches || reducedMotion.matches) return;
      var box = stage.getBoundingClientRect();
      var x = (event.clientX - box.left) / box.width - 0.5;
      var y = (event.clientY - box.top) / box.height - 0.5;
      phone.style.setProperty('--tilt-y', (x * 22 - 4).toFixed(2) + 'deg');
      phone.style.setProperty('--tilt-x', (-y * 14 + 2).toFixed(2) + 'deg');
    });
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var wasInView = inView;
        inView = entry.isIntersecting;
        if (inView === wasInView) return;
        if (inView) {
          restartProgress();
          schedule();
        } else {
          stop();
        }
      });
    }, { threshold: 0.35 }).observe(section);
  }

  document.addEventListener('visibilitychange', function() {
    if (document.hidden) stop();
    else if (inView) {
      restartProgress();
      schedule();
    }
  });

  setStep(0);
})();
